<template>
  <div class="pg-company">
      <div class="company-wrapper">
        <header>
            <!-- <div class="logo">
                <img :src="companyData.company&&companyData.company.logo" alt="公司logo" v-if="companyData.company&&companyData.company.logo">
                <img src="../../assets/images/company-default.png" alt="公司logo" v-else>
            </div>
            <div class="company-right">
                <h3>{{companyData.company&&companyData.company.companyName}}</h3>
                <p><strong>{{companyData.counts}}</strong>种化学产品</p>
            </div>
            <div class="view-product">
                <router-link :to="{path:'/companypro',query:{cid:cid}}">查看产品</router-link>
            </div> -->
            <div class="toptitle">
              <img :src="companyData.company&&companyData.company.logo"  alt=""  class="compony-logo" v-if="companyData.company&&companyData.company.logo"/> 
              <img src="../../assets/images/compony-default.png"  alt=""  class="compony-logo" v-if="companyData.company&&companyData.company.logo == '' "/> 
              <div class="compony-info">
                <p class="top">
                  <span class="name">{{ companyData.company&&companyData.company.companyName }}</span>
                  <router-link class="product" :to="{path:'/companypro',query:{cid:cid}}"><span class="f-right product">{{ companyData.counts }}个产品</span></router-link>
                </p>
                <p class="slogan" :data-text="companyData.company ? companyData.company.description : '' ">简介：
                 
                {{companyData.company  && companyData.company.description ? companyData.company.description.length > 25 ? companyData.company.description.slice(0, textLength) : companyData.company.description : '' }}
                 <span v-show=" companyData.company  && companyData.company.description ? companyData.company.description.length > 25 : false"  :style="{color: '#3f89f7'}" @click="textCut(companyData.company.description)"> {{textLength <= 25 ? '展开' : '收起'}}</span>
                </p>
              </div>
            </div>
        </header>
        <div class="company-info">
            <div class="info-item">
                <label class="product-lbl">主营产品：</label>
                <span>{{companyData.company&&companyData.company.mainProducts}}</span>
            </div>
            <div class="info-item">
                <label class="location-lbl">公司地址：</label>
                <span>{{companyData.company && ( companyData.company.addresses[0] && companyData.company.addresses[0].address ) }}</span>
            </div>
        </div>
      </div>
        <h2>智能搜索</h2>
        <ul class="tabs clearfix">
            <li :class="tabsActive==1?'active':''"><a href="javascript:;" @click.prevent="switchTabs(1)">产品中心</a></li>
            <li :class="tabsActive==2?'active':''"><a href="javascript:;" @click.prevent="switchTabs(2)">应用市场</a></li>
            <li :class="tabsActive==3?'active':''"><a href="javascript:;" @click.prevent="switchTabs(3)">配方指南</a></li>
        </ul>
        <div class="category-wrapper">
           
            <div class="category3">
                <dl class="clearfix">
                    <dd  v-for="cate2 in cateBodyData" :key="cate2.id">{{cate2.name}}</dd>
                </dl>
            </div>
        </div>
  </div>
</template>
<script>
import Jroll from 'jroll';
import axios from 'axios';
import { Loading,Message } from 'element-ui';
import config  from  '../../common/config';

export default {
  name:'company',
  data () {
      return {
          tabsActive:1,
          companyData:"",
          cateBodyData:"",
          cid:'',
          textLength: 25,
      }
  },
  metaInfo: {
      meta: [
          { name:"keywords",  content:"优料库,配方,原材料,在线课堂,MSDS,TDS,产品手册,免费申请"},
          { name:"description", content:"在线支持原料性能搜索,通过覆盖全球供应商的产品数据库资源,为用户提供数据查询、资料下载、在线培训和试样申请等专业信息服务。" }
      ],
  },

  mounted () {
    //   this.lv1Rroll = new JRoll("#lv1Wrapper", {scrollBarY: false, scrollBarFade: false});
      let loadingInstance = Loading.service({text: '加载中...',spinner: 'el-icon-loading',background: 'rgba(255, 255, 255, 0.7)'});
      let _id = this.$route.query.id;
      this.cid = _id;
      _hmt.push(['_trackPageview', `/#/company?id=${_id}`]);
      axios.get(config.PHPHOST+'api/web/index.php?r=company/company-particulars&partId='+_id).then(
          function(res){
              if (res.data.flag !== 0) {
                  Message({
                    message:res.data.msg,
                    showClose:false,
                    customClass:'search-msg-style',
                    duration:3000
                    })
                }else{
                    this.companyData = res.data.data;
                    this.cateBodyData = res.data.data.productCate;

                    //this.companyData.company.description="在线支持原料性能搜索,通过覆盖全球供应商的在线支持原料性能搜索,通过覆盖全球供应商的";

                    WeChatShare({
                      callback: () => {
                        var title = (this.companyData.company && this.companyData.company.companyName) + '-优料库',
                            desc = this.companyData.company && this.companyData.company.description || '在线支持原料性能搜索,通过覆盖全球供应商的产品数据库资源,为用户提供数据查询、资料下载、在线培训和试样申请等专业信息服务。',
                            imgUrl = config.PHPHOST + 'frontend/web/images/logo-new.jpg',
                            link = window.location.origin + '?path=company&id=' + this.cid;

                        wx.onMenuShareAppMessage({
                            title: title,
                            desc: desc,
                            link: link,
                            imgUrl: imgUrl
                        });
                        wx.onMenuShareTimeline({
                            title: title + " - " + desc,
                            link: link,
                            imgUrl: imgUrl
                        });
                      },
                      data: 'url=' + encodeURIComponent(window.location.href),
                      url: config.MAPI
                    });

                    // console.log(this.companyData, 'companyData')
                };
                loadingInstance.close();
          }.bind(this),
          function(err){

          }
      ).catch(
          function(err){

          }
      )


  },
  methods: {
    // 截取字符串
    textCut(data) {
      if (this.textLength <= 25) {
        this.textLength = data.length;
      }else {
        this.textLength = 25;
      }
    },
    switchTabs(m){
        this.tabsActive = m;
        switch (m) {
              case 1:
                  this.cateBodyData = this.companyData.productCate;
                  break;
              case 2: 
                  this.cateBodyData = this.companyData.applicationCate;
                  break;
              case 3: 
                  this.cateBodyData = this.companyData.formulaCate;
                  break;
            default:
                  this.cateBodyData = this.companyData.productCate;
                break;
        }
    }
  }
}
</script>
<style lang='less'>
.company-wrapper {
    header {
        display: flex;
        position: relative;
        border-bottom: .1rem solid #e1e1e1;
        padding-bottom: 1rem;
         .toptitle {
            display: flex;
            height: auto;
            width: 100%;
            padding: 1rem;
            line-height: 4rem;
            .compony-logo {
              width: 6.6rem;
              height: 6.6rem;
              margin-right: 1rem;
              border: 1px solid #e4e4e4;
            }
            .compony-info {
              line-height: 1.4rem;
              flex: 1 1 ;
            }
            .f-right {
              float: right;
            }
            .name {
              width: 60%;
              float: left;
              font-size: 1.4rem;
              font-weight: 600;

            }
            .product {
              font-size: 1.2rem;
              color: #0994ff;
            }
            .slogan {
              float: left;
              width: 100%;
              margin-top: 1.5rem;
              font-size: 1.2rem;
              color: #999;
            }
            .line-clamp-1 {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
            }
        }
        h3 {
            margin-top: .5rem;
            font-size: 1.6rem;
            line-height: 2rem;;
        }
        p {
            margin-top: 1rem;
            font-size: 1.4rem;
            strong {
                color: #0994ff;
                margin-right: .5rem;

            }
        }
    }
    .logo {
        width: 6rem;
        height: 6rem;
        margin-left: 1rem;
        margin-right: 1rem;
        flex:none;
        border-radius: .4rem;
        border: .1rem solid #e1e1e1;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .company-right {
        flex: 1;
        line-height: 2.6rem;
        
    }
    .view-product {
        text-align: center;
        position: absolute;
        right: 1rem;
        top: 3rem;
        border: .1rem solid #0994ff;
        border-radius: 4px;
        a {
            display: block;
            color: #0994ff;
            padding: .2rem .5rem;
            font-size: 12px;
        }
    }
    .company-info {
        margin-top: 1rem;
        padding-bottom: 1rem;
        border-bottom: 1rem solid #f5f5f5;
        .info-item {
            line-height: 1.6rem;
            padding-left: 3rem;
            display: flex;
            label {
                color: #999;
                flex:none;
                position: relative;
            }
            .product-lbl::before {
                    content:'';
                    display: block;
                    position: absolute;
                    width: 1.5rem;
                    height: 1.5rem;
                    background: url('../../assets/images/product-icon.png') center no-repeat;
                    background-size: contain;
                    left:-2rem;
                    top:.3rem;
                }
            .location-lbl::before {
                content:'';
                display: block;
                position: absolute;
                width: 1.5rem;
                height: 1.5rem;
                background: url('../../assets/images/location.png') center no-repeat;
                background-size: contain;
                left:-2rem;
                top:.3rem;
            }
            span {
                flex:1;
            }
        }
    }
}
.pg-company {
    height: 100%;
    box-sizing: border-box;
    h2 {
        font-size: 1.8rem;
        line-height: 2.6rem;
        padding-left: 1rem;
        border-bottom: .1rem solid #f3f3f3;
        padding-top: .5rem;
        padding-bottom: .5rem;

    }
    .tabs {
        display: flex;
        li {
            flex:1;
            line-height: 4rem;
            border-bottom: .1rem solid #f3f3f3;
            text-align: center;
            font-size: 1.4rem;
            padding-left: 1rem;
            padding-right: 1rem;
            a {
                display: block;
            }
            &.active {
                a {
                   color: #0994ff;
                    border-bottom: .2rem solid #0994ff; 
                }
                
            }
        }
    }
    .category-wrapper {
        flex:1;
        display: flex;
        overflow-y: scroll;
        .category2 {
        background-color: #f3f4f5;
        width: 10rem;
            li {
                line-height: 3rem;
                font-size: 1.3rem;
                text-align: center;
                a {
                    position: relative;
                    display: block;
                    &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    margin-left: -2.1rem;
                    width: 4.2rem;
                    height: .2rem;
                    border-bottom: .1rem solid #ddd;
                    }
                }
                &.active {
                    background-color: #fff;
                    a {
                        &::after {
                            content: '';
                            display: none;
                        }
                        &::before {
                            content:"";
                            position: absolute;
                            height: 2rem;
                            width: .3rem;
                            background-color: #0994ff;
                            left: 0;
                            top: .5rem;
                        }
                    }
                }
            }
        }
        .category3 {
            dl {
                padding-bottom: 1rem;
                dt {
                    margin-top: 1rem;
                    line-height: 3rem;
                    padding-left: 1rem;
                    font-size: 1.6rem;
                    font-weight: 600;
                    color: #0994ff;
            }
            dd {
                float: left;
                padding:.5rem 1rem;
                box-sizing: border-box;
                margin-bottom: .5rem;
            }
            }
            

        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/company/index.vue